<script setup>
  const props = defineProps({
    error: {
      type: Object,
      required: true
    }
  })
</script>

<template>
  <div class="jwx-error">
    <h2 v-if="props.error.header" class="jwx-error__header">{{ props.error.header }}</h2>
    <p class="jwx-error__title">{{ props.error.title }}</p>
    <p class="jwx-error__message">{{ props.error.message }}</p>
    <p v-if="props.error.errorText" class="jwx-error__error-text">Error: <span v-html="props.error.errorText"></span></p>
  </div>
</template>